import axios from "axios";

export const handleFindOptionsMunicipios = async (valueMunicipio = '') => {
  const city = await axios.post(
    '/api/municipios/get-municipios-by-caracter',
    {
      cidade: valueMunicipio,
      withRelation: 'concessionarias',
    }
  );

  const newarray = [];
  // const array = data.data;

  city.data.map(async (item) => {
    var objCidades = [];

    item.cidades.map((c) => {
      objCidades.push({
        value: `${c.attributes.nome} - ${c.attributes.uf}`,
        label: `${c.attributes.nome} - ${c.attributes.uf}`,
        concessionarias: c.attributes.concessionarias?.data ?? [],
        id: `${c.id}`,
      });
    });
    newarray.push({
      label: item.nome,
      options: objCidades,
    });
  });
  return newarray;
}